<!--
 * @Author: zhwenlong 2546258285@qq.com
 * @Date: 2022-05-18 09:07:11
 * @LastEditors: zhwenlong 2546258285@qq.com
 * @LastEditTime: 2022-05-18 11:24:50
 * @FilePath: \fore\src\publicElement\zg-mask\index.vue
 * @Description:
 *
 * Copyright (c) 2022 by zhwenlong 2546258285@qq.com, All Rights Reserved.
-->
<template>
  <!-- 弹框 -->
  <div class="zg_mask_dialog" v-if="digStatus">
    <div class="el-dialog" :style="{ width: size }">
      <div class="el-dialog__header">
        <span class="el_dialog_title">{{ title }}</span>
        <i class="iconfont icon-iconfonticon02" @click="digStatus = false"></i>
      </div>
      <div class="">
        <div class="">
          <slot name='header'></slot>
        </div>
        <div class="mask_form">
          <div class="paddingLR _customScroll" :class="{ scroll: scroll }">
            <slot name="body"></slot>
          </div>
          <div class="paddingLR">
            <slot name="foot"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 弹框标题
    title: {
      type: String,
      default: "详情",
    },
    size: {
      type: String,
      default: "840px",
    },
    // 是否可以滚动
    scroll: {
      type: Boolean,
      default: false,
    },
    // 弹框开关
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    digStatus: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    // 确定
    sccuess() {
      if (!this.sccuessdisabled) {
        this.$emit("sccuess");
      }
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.zg_mask_dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.35);
  z-index: 666;
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-dialog {
  background: #ffffff;
  display: inline-block;
  .el-dialog__header {
    // width: 100%;
    height: 40px;
    line-height: 40px;
    padding: 0 9px;
    background: @primaryColorMix05;
    display: flex;
    justify-content: space-between;
    .el_dialog_title {
      font-size: 14px;
      color: #000;
      font-weight: bold;
    }
    i {
      font-size: 16px;
      transform: rotate(45deg);
      cursor: pointer;
      color: #272536;
    }
  }
  .mask_form {
    padding: 40px 0;
  }
  .paddingLR {
    padding: 0 40px;
  }
  .scroll {
    max-height: 400px;
    overflow: auto;
  }
}
</style>
